/* Mastro - Install Capability Foundation (MS-PWA3-A)
 * Captures `beforeinstallprompt` at import time so the event is not lost
 * before the user opens Impostazioni. Keeps the deferred prompt in memory only.
 * No backend, no localStorage, no sessionStorage.
 */

let deferredPrompt = null;
const listeners = new Set();

const isBrowser = typeof window !== "undefined";

function isStandalone() {
  if (!isBrowser) return false;
  const mql = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
  const iosStandalone = window.navigator && window.navigator.standalone === true;
  return Boolean(mql || iosStandalone);
}

function isIOS() {
  if (!isBrowser) return false;
  const ua = window.navigator.userAgent || "";
  const iOSDevice = /iPad|iPhone|iPod/.test(ua);
  // iPadOS 13+ reports as Mac; detect via touch support.
  const iPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  return iOSDevice || iPadOS;
}

let state = {
  installed: false,
  standalone: isStandalone(),
  ios: isIOS(),
  canInstall: false,
};

function emit() {
  listeners.forEach((l) => l());
}

function setState(next) {
  state = { ...state, ...next };
  emit();
}

if (isBrowser) {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    setState({ canInstall: true });
  });

  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    setState({ installed: true, canInstall: false, standalone: true });
  });
}

export function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getSnapshot() {
  return state;
}

export async function promptInstall() {
  if (!deferredPrompt) return { outcome: "unavailable" };
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  if (choice && choice.outcome === "accepted") {
    deferredPrompt = null;
    setState({ canInstall: false });
  }
  return choice;
}
